'use strict';

angular.module('validationBubble', [])
.directive('suppressValidationBubble', function() {
	return {
		restrict: 'A',
		link: function(scope, element, attrs) {
			element.on('invalid', function(event) {
				event.preventDefault();
			});
		}
	};
});